<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >申请人姓名 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.username"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属公司 :
              </span>
              <div class="width300">
                <el-select v-model="searchData.factoryId" clearable>
                  <el-option
                    v-for="item in classifyList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 textAlignRight width80"
                >状态 :
              </span>
              <div class="width300">
                <el-select v-model="searchData.state" clearable>
                  <el-option
                    v-for="item in OMemberExamine"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                </el-date-picker>
              </div>
            </div> -->
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="role" slot-scope="{ row }">
        {{ MMemberRole[row.role] || "" }}
      </template>

      <template slot="state" slot-scope="{ row }">
        {{ MMemberExamine[row.state] || "" }}
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button
          type="text"
          size="mini"
          @click="batch(row.id)"
          v-if="row.state == EMemberExamine.PendingReview"
          >审核</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      title="审核"
      :visible.sync="dialogVisible"
      :custom-class="dialogHidden ? 'hidden-dialog-content' : ''"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form
        ref="form"
        :defaults.sync="defaults"
        v-model="form"
        :option="formOption"
      >
        <!-- <template slot="details"> </template> -->

        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            :loading="showLoadingForm"
            @click="submit(form)"
            >确定</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  memberExamineList,
  memberExamineStateUpdate,
} from "@/api/user/examine";
import { manageFactoryList } from "@/api/user/manage";
import dayjs from "dayjs";
import {
  EMemberExamine,
  MMemberExamine,
  OMemberExamine,
  MMemberRole,
  OMemberRole,
} from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  data() {
    return {
      EMemberExamine: EMemberExamine,
      MMemberExamine: MMemberExamine,
      OMemberExamine: OMemberExamine,
      MMemberRole: MMemberRole,
      OMemberRole: OMemberRole,
      defaults: {},
      searchData: {
        title: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        tip: false,
        column: [
          {
            label: "公司名称",
            prop: "companyName",
          },
          {
            label: "申请人姓名",
            prop: "username",
          },
          // {
          //   label: "岗位",
          //   prop: "post",
          // },
          {
            label: "手机号码",
            prop: "phone",
          },

          {
            label: "审核状态",
            prop: "state",
          },
          {
            label: "理由",
            prop: "reason",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      dialogHidden: false,
      form: {
        state: 2,
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "审核操作",
            prop: "state",
            type: "radio",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
            dicData: [
              {
                value: 2,
                label: "同意",
              },
              {
                value: 3,
                label: "拒绝",
              },
            ],
          },
          {
            label: "角色",
            prop: "role",
            type: "select",
            span: 12,
            display: true,
            dicData: OMemberRole,
            rules: [
              {
                required: true,
                message: "请选择角色",
                trigger: "change",
              },
            ],
          },
          {
            label: "拒绝原因",
            prop: "reason",
            type: "textarea",
            span: 24,
            row: true,
            display: false,
            minRows: 3,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      delId: "",
      delType: "", //1批量 2 单个
      classifyList: [], //所属公司分类
    };
  },
  watch: {
    "form.state"(val) {
      if (val == 3) {
        this.defaults.reason.display = true;
        this.defaults.role.display = false;
      } else {
        this.defaults.reason.display = false;
        this.defaults.role.display = true;
      }
    },
  },
  created() {
    this.getClassifyList();
  },
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      memberExamineList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        details: "",
        id: "",
      };
      this.dialogVisible = true;
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.dialogHidden = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    // 重置表单
    resetForm() {
      this.dialogHidden = false;
      this.form = {
        state: 2,
      };
    },
    //编辑
    async handleEdit(row) {
      console.log(row);
      this.form.id = row.id;
      this.dialogVisible = true;
      this.form = { ...row, details: row.content };
    },
    //审核
    batch(id, type) {
      this.delId = id;
      this.dialogVisible = true;
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          memberExamineStateUpdate({
            id: this.delId,
            ...form,
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("审核成功!");
                this.onLoad();
                this.dialogVisible = false;
              } else if (res.code === 435) {
                this.handleFactoryIncomplete(res.msg);
              } else {
                this.$message.error(res.msg || "操作失败");
              }
              this.showLoadingForm = false;
            })
            .catch(() => (this.showLoadingForm = false));
        }
      });
    },
    /**
     * 处理接口返回435（盘厂资料未完善）提示并引导跳转盘厂列表
     * 通过无缝切换遮罩层并平滑隐藏当前弹窗，避免弹窗切换时的白屏闪烁
     * @param {string} msg 接口返回的错误提示信息
     * @returns {void}
     */
    handleFactoryIncomplete(msg) {
      this.dialogHidden = true;
      this.$confirm(
        
          "盘厂资料未完善，请前往【社区联盟-盘厂列表】点击【编辑】，填写盘厂档案信息",
        "提示",
        {
          confirmButtonText: "去完善",
          showCancelButton: false,
          showClose: false,
          closeOnPressEscape: false,
          type: "warning",
          closeOnClickModal: false,
          beforeClose: (action, instance, done) => {
            done();
            this.handleClose();
          },
        }
      )
        .then(() => {
          this.goToFactoryManage();
        })
        .catch(() => {});
    },
    /**
     * 跳转至盘厂管理页面并同步更新左侧菜单选中项与顶部标签栏
     * 采用路径归一化、包含关系与菜单名称多级容错匹配，结合异步二次高亮机制确保菜单项精准展开并激活
     * @returns {void}
     */
    goToFactoryManage() {
      const targetUrl = "/factory/manage";
      const menuList = this.$store.state.index.menu || [];
      let targetName = "盘厂列表";
      let subMenuIndex = "";

      // 路径归一化辅助函数，移除首尾斜杠与首尾空格
      const normalizeUrl = (url) => (url || "").trim().replace(/^\/+|\/+$/g, "");
      const normalizedTarget = normalizeUrl(targetUrl);

      // 第一优先级：路径归一化后完全匹配
      for (let i = 0; i < menuList.length; i++) {
        const item = menuList[i];
        if (item && item.children && item.children.length) {
          for (let j = 0; j < item.children.length; j++) {
            const child = item.children[j];
            if (child && normalizeUrl(child.url) === normalizedTarget) {
              targetName = child.name || targetName;
              subMenuIndex = `${i + 1}-${j + 1}`;
              break;
            }
          }
        }
        if (subMenuIndex) break;
      }

      // 第二优先级：路径包含关系匹配（如子路由包含 factory/manage）
      if (!subMenuIndex) {
        for (let i = 0; i < menuList.length; i++) {
          const item = menuList[i];
          if (item && item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j];
              if (
                child &&
                child.url &&
                (normalizeUrl(child.url).includes(normalizedTarget) ||
                  normalizedTarget.includes(normalizeUrl(child.url)))
              ) {
                targetName = child.name || targetName;
                subMenuIndex = `${i + 1}-${j + 1}`;
                break;
              }
            }
          }
          if (subMenuIndex) break;
        }
      }

      // 第三优先级：菜单名称精准或模糊匹配“盘厂列表”
      if (!subMenuIndex) {
        for (let i = 0; i < menuList.length; i++) {
          const item = menuList[i];
          if (item && item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j];
              if (
                child &&
                child.name &&
                (child.name === "盘厂列表" || child.name.includes("盘厂列表"))
              ) {
                targetName = child.name;
                subMenuIndex = `${i + 1}-${j + 1}`;
                break;
              }
            }
          }
          if (subMenuIndex) break;
        }
      }

      // 第四优先级：使用全局方法 $globalMethod 兜底查找
      if (!subMenuIndex && this.$globalMethod) {
        subMenuIndex =
          this.$globalMethod(targetUrl) ||
          this.$globalMethod("factory/manage") ||
          "";
      }

      // 1. 同步设置 Vuex 中菜单激活索引并派发事件
      if (subMenuIndex) {
        this.$store.commit("setSubMenuIndex", subMenuIndex);
        this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
      }

      // 2. 触发顶部标签栏（Tab）新增或激活
      const tableTabs = this.$store.state.index.tableTabs || [];
      let exist = false;
      const tabData = {
        title: targetName,
        name: "0",
        url: targetUrl,
        index: subMenuIndex || "0",
      };

      tableTabs.forEach((item) => {
        if (
          (item.title && (item.title === tabData.title || item.title === "盘厂列表")) ||
          (item.url && normalizeUrl(item.url) === normalizedTarget)
        ) {
          tabData.name = item.name;
          exist = true;
        }
      });

      if (!exist) {
        let maxName = 0;
        tableTabs.forEach((item) => {
          const num = Number(item.name);
          if (!isNaN(num) && num > maxName) {
            maxName = num;
          }
        });
        tabData.name = (maxName + 1).toString();
      }

      this.$root.eventHub.$emit("changeTableTabs", { type: exist, data: tabData });

      // 3. 执行路由跳转
      this.$router.push({
        path: targetUrl,
      });

      // 4. 在微任务与延时宏任务中二次派发，确保路由切换完成后的稳定高亮与展开
      if (subMenuIndex) {
        this.$nextTick(() => {
          this.$store.commit("setSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeTableTabs", { type: true, data: tabData });
        });
        setTimeout(() => {
          this.$store.commit("setSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
        }, 150);
      }
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //详情
    handleDetails(row) {
      this.$router.push({
        path: "/examine/create",
        query: {
          id: row.id,
          type: "view",
        },
      });
    },
    //会员分类
    getClassifyList() {
      manageFactoryList({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .hidden-dialog-content {
  visibility: hidden !important;
  opacity: 0 !important;
}
</style>
